import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const industryApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getIndustries: builder.query({
      query: () => `/industries/`,
      providesTags: (result, error, arg) => [{ type: 'Industry', id: 'LIST' }],
    }),
    createIndustry: builder.mutation({
      query: (industry) => ({
        url: '/industries/',
        method: 'POST',
        body: industry
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: [{ type: 'Industry', id: 'LIST' }],
    }),
    deleteIndustry: builder.mutation({
      query: (industryId) => ({
        url: `/industries/${industryId}`,
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'Industry', id: 'LIST' }
      ]
    }),
  }),
  overrideExisting: false
})

export const {
  useGetIndustriesQuery,
  useCreateIndustryMutation,
  useDeleteIndustryMutation
} = industryApiSlice
